"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPortalAccessOut = void 0;
class AppPortalAccessOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return AppPortalAccessOut.attributeTypeMap;
    }
}
exports.AppPortalAccessOut = AppPortalAccessOut;
AppPortalAccessOut.discriminator = undefined;
AppPortalAccessOut.attributeTypeMap = [
    {
        "name": "token",
        "baseName": "token",
        "type": "string",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=AppPortalAccessOut.js.map